import { withInstall, withNoopInstall } from '@sgui-plus/utils/with-install'

import Select from './src/select.vue'
import Option from './src/option.vue'
import OptionGroup from './src/option-group.vue'

export const SgSelect = withInstall(Select, {
  Option,
  OptionGroup,
})
export default SgSelect
export const SgOption = withNoopInstall(Option)
export const SgOptionGroup = withNoopInstall(OptionGroup)

export * from './src/token'
